import * as React from 'react';
import type { StudyPortfolioSectionBlockViewModel } from '../ViewModel/StudyPortfolioSectionBlockViewModel.csharp';
import { StudyPortfolioSection } from '~/Features/StudyPage/Campus/Sections/StudyPortfolioSection/StudyPortfolioSection';
import { mapToPortfolioItems } from './Utils/PortfolioItemsUtils';

export const StudyPortfolioSectionBlock: React.FC<StudyPortfolioSectionBlockViewModel> = props => {
    const { id, title, teaser, portfolioItems, callToAction } = props;

    return (
        <StudyPortfolioSection
            id={id}
            title={title}
            teaser={teaser}
            items={mapToPortfolioItems(portfolioItems)}
            callToAction={callToAction}
        />
    );
};
